<script setup lang="ts">
import { onMounted, reactive } from "vue";
import { ComplianceStatus, ComplianceCategory } from "~/types/ComplianceTypes";
import { useEntityDefinitionStore } from "~/stores/EntityDefinitionStore";
const entityDefinitionStore = useEntityDefinitionStore();

const emit = defineEmits<{
  (e: "submit:query", value: typeof complianceQueryInput): void;
}>();

onMounted(async () => {
  await entityDefinitionStore.load();
});

const complianceQueryInput = reactive<{
  type: string[];
  importance: string[];
  status: string[];
  search: string;
}>({
  type: [],
  importance: [],
  status: [],
  search: "",
});

const handleQuery = () => {
  const query = { ...complianceQueryInput };
  emit("submit:query", query);
};
</script>

<template>
  <div class="ComplianceQuery">
    <el-form
      :model="complianceQueryInput"
      label-width="auto"
      label-position="top"
      class="compliance-query"
    >
      <el-form-item>
        <el-input
          v-model="complianceQueryInput.search"
          placeholder="Search"
          style="width: 240px"
          clearable
          @input="handleQuery"
        />
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="complianceQueryInput.type"
          placeholder="Type"
          style="width: 240px"
          :clearable="true"
          :multiple="true"
          filterable
          @change="handleQuery"
        >
          <el-option
            v-for="type in entityDefinitionStore.EntitiesDefinitionList"
            :key="type.guid"
            :label="type.name ?? undefined"
            :value="type.guid"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="complianceQueryInput.importance"
          placeholder="Importance"
          style="width: 240px"
          :clearable="true"
          :multiple="true"
          filterable
          @change="handleQuery"
        >
          <el-option
            v-for="(key, value) in ComplianceCategory"
            :key="key"
            :label="key"
            :value="value"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="complianceQueryInput.status"
          placeholder="Status"
          style="width: 240px"
          :clearable="true"
          :multiple="true"
          filterable
          @change="handleQuery"
        >
          <el-option
            v-for="(value, key) in ComplianceStatus"
            :key="key"
            :label="key"
            :value="value"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <slot name="create-button"></slot>
  </div>
</template>

<style lang="less">
.ComplianceQuery {
  .el-form {
    display: grid;
    grid-template-columns: repeat(4, minmax(100px, 1fr));
    gap: 20px;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
  .new-button {
    float: right;
  }
}
</style>
